<!--
 * @Author: 
 * @Date: 2022-11-11 18:43:50
 * @LastEditors: Yuan Wei Lin
 * @LastEditTime: 2023-08-18 15:14:38
 * @Description: 
-->
<template>
  <div class="model_dialog" v-if="show">
    <div
      class="content"
      :style="{
        width: width || '800px',
        minWidth: width || '800px',
        height: height || '600px',
        minHeight: height || '600px',
        overflow: 'hidden',
      }"
    >
      <div class="title">
        <p>{{ title || "---" }}</p>
        <el-icon @click="close">
          <Close />
        </el-icon>
      </div>
      <div
        class="main_content global_scroll_bar"
        :class="{
          buttonShowFalse: !buttonShow,
          buttonShowTrue: buttonShow,
        }"
      >
        <!-- 组件页面 -->
        <slot name="contents"></slot>
        <!-- 调用案例 -->
        <!-- <template v-slot:content> </template> -->
      </div>
      <div class="main_button_box2" v-show="buttonShow"></div>
      <div class="main_button_box" v-show="buttonShow">
        <div class="close_buttons" @click="close"><p>取消</p></div>
        <div class="sure_buttons" @click="Sure">
          <p>{{ sureButtonText || "确认" }}</p>
        </div>
        <div class="sure_button" v-if="continueButton" @click="continueSure">
          <p>保存并继续</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["buttonShow", "height", "width", "continueButton", "sureButtonText"],
  data() {
    return {
      show: false,
      title: "",
      buttonShow: this.buttonShow,
    };
  },
  methods: {
    // 打开弹窗
    OpenDialog() {
      this.show = true;
    },

    // 关闭弹窗
    CloseDialog() {
      this.show = false;
    },

    // 取消按钮
    close() {
      this.$emit("close");
    },

    // 确认按钮
    Sure() {
      this.$emit("sure");
    },

    // 继续保存按钮--只用于班级信息维护中,新增弹窗
    continueSure() {
      this.$emit("continueSure");
    },
  },
};
</script>
<style scoped lang="less">
.buttonShowTrue {
  height: calc(100% - 32px - 80px);
  overflow-y: auto;
}

.buttonShowFalse {
  height: calc(100% - 40px);
  overflow-y: auto;
}

.model_dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  z-index: 4;
  .content {
    background-color: #fff;
    position: relative;
    overflow-y: auto;
    border-radius: 4px;
    > div {
      box-sizing: border-box;
    }
    .title {
      user-select: none;
      width: 100%;
      height: 40px;
      font-size: 16px;
      background: #f5f5f5;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      /deep/ .el-icon {
        cursor: pointer;
        position: absolute;
        right: 20px;
        font-size: 18px;
      }
      /deep/ .el-icon:hover,
      .el-icon:active {
        color: rgb(36, 162, 226);
      }
    }
    .main_button_box2 {
      width: 100%;
      height: 70px;
    }
    .main_button_box {
      user-select: none;
      width: 100%;
      position: absolute;
      bottom: 18px;
      display: flex;
      // align-items: center;
      justify-content: center;
      font-size: 16px;
      margin-top: 20px;
      box-sizing: border-box;
      padding-top: 10px;
      .close_buttons {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 74px;
        height: 36px;
        border: 1px solid #c1c1c1;
        border-radius: 24px;
        color: #212121;
        font-size: 14px;
        padding: 8px 16px;
        box-sizing: border-box;
      }
      .sure_buttons {
        cursor: pointer;
        margin-left: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 74px;
        height: 36px;
        background: @unify-color;
        border-radius: 24px;
        color: #fff;
        font-size: 14px;
        padding: 8px 16px;
        box-sizing: border-box;
      }
    }
  }
}
</style>
